
let relApi = '/apiRel';
let env = ''
let socketUrl = ''

let getENV = function (name) {
    const names = location.protocol + '//' + location.host;
    return names.indexOf(name) >= 0;
}

if (getENV('localhost')) { //本地开发环境
    env = 'local_dev';
    relApi = '/apiRel';
    // socketUrl = 'wss://netty.dev.yunduocrm.cn/websocket';
    socketUrl = 'ws://netty.rel.yunduocrm.cn/websocket';
} else {
    relApi = '/api';
    if (getENV('visitor.rel.yunduocrm.cn')) { //开发环境
        env = 'development';
        relApi = 'http://visitor.rel.yunduocrm.cn/api';
        socketUrl = 'ws://netty.rel.yunduocrm.cn/websocket';
    } else if (getENV('visitor.dev.yunduocrm.cn')) { //测试环境
        env = 'testing';
        socketUrl = 'ws://netty.dev.yunduocrm.cn/websocket';
    } else if (getENV('visitor.yunduocrm.com')) { //线上环境
        env = 'production';
        relApi = 'https://visitor.yunduocrm.com/api';
        socketUrl = 'wss://kfnetty.yunduocrm.com/websocket';
    } else {
      env = 'production';
      relApi = 'https://visitor.yunduocrm.com/api';
      socketUrl = 'wss://kfnetty.yunduocrm.com/websocket';
    }
}

console.log('访客环境', env);


export const LogUrl = "https://log.yunduocrm.com/api";
//export const LogUrl = "http://visitor.rel.yunduocrm.cn/api";

export default {
  relApi,
  NODE_ENV: env,
  socketUrl,
  LogUrl
}



// WEBPACK FOOTER //
// ./src/fetch/config/index.js